import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { replace } from '../../services/router-utils';
import search, { MIN_QUERY_LENGTH } from '../../actions/search';
import { setIsLoaded } from '../../actions/set-is-loaded';
import { setIsLoading } from '../../actions/set-is-loading';
import { pageOpened } from '../../actions/page-opened';
import SearchInput from '../../components/search-input';
import BreadcrumbsWidget from '../../containers/breadcrumbs-widget';
import { SEARCH_RESULTS } from '../../services/detect-route';
import { isInitialLocation } from '../../selectors/location-history-selectors';

const DEBOUNCE_WAIT = 200;

export class SearchHeader extends Component {
  componentWillMount() {
    const { query, isInitialLocation } = this.props;
    if (query && query.length >= MIN_QUERY_LENGTH && !isInitialLocation) {
      this.props.setIsLoading('search', '', true);
    }
  }

  componentDidMount() {
    this.props.onSearch(this.props.query);
    this.props.pageOpened({ page: SEARCH_RESULTS });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.query !== nextProps.query) {
      this.props.onSearch(nextProps.query);
      this.props.setIsLoading('search', '', true);
    }
  }

  handleQueryChange = debounce(query => this.props.onQueryChange(query), DEBOUNCE_WAIT);

  render() {
    const {
      component: Component,
      left,
      query,
      inputClassName,
      iconClassName,
      borderClassName,
      showWidget,
      ...props
    } = this.props;

    const searchInput = (
      <SearchInput
        isExpanded
        isFullWidth={!showWidget}
        value={query}
        onChange={this.handleQueryChange}
        inputClassName={inputClassName}
        iconClassName={iconClassName}
        borderClassName={borderClassName}
      />
    );

    let right;
    if (showWidget) {
      right = <BreadcrumbsWidget searchInput={searchInput}/>;
    } else {
      right = searchInput;
    }

    return <Component left={left} right={right} {...props}/>;
  }
}

SearchHeader.propTypes = {
  component: PropTypes.any,
  left: PropTypes.node,
  query: PropTypes.string.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  borderClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  pageOpened: PropTypes.func,
  isInitialLocation: PropTypes.bool.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  showWidget: PropTypes.bool,
};

SearchHeader.defaultProps = {
  showWidget: true,
};

const mapStateToProps = (state, ownProps) => ({
  query: ownProps.location.query.query || '',
  isInitialLocation: isInitialLocation(state),
});

const buildLocation = (location, query) => {
  if (query) {
    return {
      ...location,
      pathname: location.pathname === '/search' ? '/search/posts' : location.pathname,
      query: { query },
    };
  }
  return '/search';
};

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      onQueryChange: query => replace(buildLocation(ownProps.location, query)),
      onSearch: search,
      pageOpened,
      setIsLoading,
      setIsLoaded,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SearchHeader);



// WEBPACK FOOTER //
// ./app/containers/search-header/search-header.js